'use strict';

exports.__esModule = true;
/*=====================================
    一些常用的method

    Author: Gray
    CreateTime: 2020 / 12 / 03
=====================================*/

/*--------------------------
    Variable
--------------------------*/
var YOUTUBE_MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
var MATCH_URL = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[.\!\/\\w]*))?)/i;

/*--------------------------
    Methods
--------------------------*/

// ------------------------------
// 判斷是否為圖片網址
// ------------------------------
function checkIsImageUrl(url) {

    if (!url) {
        return false;
    }

    return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}

// ------------------------------
// 判斷是否為影片檔案、影片網址
// ------------------------------
function checkIsVideoFile(url, text) {

    if (!url && !text) return false;

    var urlmatch = url.match(/\.(mp4|MP4|wav|WAV|mov|MOV|avi|AVI)$/) != null;
    var textmatch = text.match(/\.(mp4|MP4|wav|WAV|mov|MOV|avi|AVI)$/) != null;

    return urlmatch || textmatch;
}

// ------------------------------
// 判斷是否為網址
// ------------------------------
function checkIsUrl(url) {

    return MATCH_URL.test(url);
}

// ------------------------------
// 判斷是否為 youtube 網址
// ------------------------------
function checkIsYoutube(url) {

    return YOUTUBE_MATCH_URL.test(url);
}

// ------------------------------
// 取得youtube縮圖網址 by id
// ------------------------------
function getYoutubeThumbnail(id) {

    if (id === null) {
        return '';
    }

    return 'https://i.ytimg.com/vi/' + id + '/0.jpg';
}

// ------------------------------
// 取得 youtube 的資料
// ------------------------------
function getYoutubeInfo(url) {

    if (!url || !checkIsYoutube(url)) {
        return undefined;
    }

    var id = url.match(YOUTUBE_MATCH_URL)[1];
    var thumburl = getYoutubeThumbnail(id);
    return {
        srcID: id,
        srcType: 'youtube',
        url: url,
        thumburl: thumburl
    };
}

/*--------------------------
    Export
--------------------------*/
var GlobalUtil = {
    checkIsImageUrl: checkIsImageUrl, // 判斷是否為圖片網址
    checkIsVideoFile: checkIsVideoFile, // 判斷是否為影片檔案、影片網址
    checkIsUrl: checkIsUrl, // 判斷是否為網址
    checkIsYoutube: checkIsYoutube, // 判斷是否為 youtube 網址
    getYoutubeThumbnail: getYoutubeThumbnail, // 取得youtube縮圖網址 by id
    getYoutubeInfo: getYoutubeInfo // 取得 youtube 的資料
};

exports.default = GlobalUtil;
module.exports = exports['default'];